<script setup>
import {ref} from "vue";

const showModal = ref(false);

const events = [
    {
        name: 'TiECon',
        url: 'https://tiesv.ai/',
        date: 'May 2025',
    },
    {
        name: 'NOAH Conf. "Digital, Sustainable, and Profitable”',
        url: 'https://www.noah-conference.com/',
        date: 'May 3',
    },
    {
        name: 'DeepTech Momentum',
        url: 'https://www.deeptech.build/',
        date: 'May 15',
    },
    {
        name: 'Axis Innovation',
        url: 'https://www.axistelaviv.com/',
        date: 'May 22',
    },
    {
        name: 'X-BA Call',
        url: false,
        date: 'June 2025',
    },
    {
        name: 'Vivatech Paris',
        url: 'https://vivatechnology.com/',
        date: '11-14 June',
    },
];

function open() {
    showModal.value = true;
}

defineExpose({
    open
});
</script>

<template>
    <b-modal v-model="showModal" title="Upcoming Events" hide-footer static>
        <ul class="list-events" style="margin-bottom: 20px">
            <li
                v-for="event in events"
                :key="event.name"
            >
                <a :href="event.url" target="_blank"><h6 class="heading6">{{ event.name }}</h6></a>
                <time class="list-events__date" datetime="">{{ event.date }}</time>
            </li>
        </ul>
    </b-modal>
</template>

<style scoped>

</style>
